type BadgeTone = "success" | "info" | "attention" | "critical";

const ACTION_MAP: Record<
  string,
  { tone: BadgeTone; labelKey: string }
> = {
  create: { tone: "success", labelKey: "audit_action_create" },
  update: { tone: "attention", labelKey: "audit_action_update" },
  delete: { tone: "critical", labelKey: "audit_action_delete" },
  view: { tone: "info", labelKey: "audit_action_view" },
  review: { tone: "info", labelKey: "audit_action_review" },
  signature: { tone: "success", labelKey: "audit_action_signature" },
  signature_complete: { tone: "success", labelKey: "audit_action_signature_complete" },
  download: { tone: "attention", labelKey: "audit_action_download" },
};

const DEFAULT: { tone: BadgeTone; labelKey: string } = {
  tone: "info",
  labelKey: "audit_action_unknown",
};

/**
 * @returns tone + i18n label key for the audit `action` enum
 */
export function getAuditActionPresentation(action: string) {
  if (ACTION_MAP[action]) {
    return ACTION_MAP[action];
  }
  return {
    tone: DEFAULT.tone,
    labelKey: `audit_action__${action}`,
  };
}
